import React, { Component } from "react";
import KickImage from 'Reuseables/KickImage';
import { connect } from "react-redux";
import { Row, Col, Container } from "reactstrap";
import Thumbnails from "../PageProductDetails/Detail/Thumbnails";
import { upcomingProductPage } from "../../actions/productAction";
import moment from "moment";
import { Link } from "react-router-dom";
import { getCloudImageUrl, emptyImage } from "../../utils";
import emptySneakerImg from "../../images/emptysneakers2.png";
import emptyApparelImg from "../../images/emptyapparels.png";
import emptyHandbagImg from "../../images/emptyhandbags.png";

/* Mobile Detection */
const valueReg3 = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i;
const valueReg4 = /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i;
let isMobile = false; //initiate as false

if (
  valueReg3.test(navigator.userAgent) ||
  valueReg4.test(navigator.userAgent.substr(0, 4))
) {
  isMobile = true;
}
/* End of Mobile Detection */

const previewSettings = {
  arrows: true,
  // autoplay:true,
  infinite: true,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 3,
  lazyLoad: true,
  dots: false,
  swipe: false,
  responsive: [
    {
      breakpoint: 480,
      settings: {
        slidesToShow: isMobile ? 1 : 1,
        slidesToScroll: isMobile ? 1 : 1
      }
    }
  ]
};

class ReleaseDate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      page: 1,
      // availables: true,
      hasMoreData: false,
      currentIndex: 0
    };
    this.changeImage = this.changeImage.bind(this);
  }

  componentDidMount() {
    this._getList();
  }

  _getList = (nextPage = null) => {
    const { page } = this.state;
    const { dataCategory } = this.props;
    this.props.getUpcomingProducts({
      params: {
        page: nextPage === null ? page : nextPage,
        category: dataCategory
      }
    });
  };

  changeImage(currentIndex) {
    this.setState({ currentIndex: currentIndex });
    // const perPage = 16;
    // const i =  perPage -5;
  }

  _handleBeforeChange = (oldIndex, newIndex) => {
    if (newIndex > oldIndex) {
      const gap = newIndex - oldIndex;
      const bagi = Math.round(this.props.dataProduct.data.length / gap);
      const median = Math.round(bagi / 2) + (bagi % 2);
      // const a = parseInt(this.props.dataProduct.data.length * 0.75);

      if (newIndex === median * gap && this.state.hasMoreData) {
        const { page } = this.state;
        this.setState({ page: page + 1 });
        this._getList(page + 1);
      }
    }
  };

  async componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.dataProduct.isFetch &&
      prevProps.dataProduct.isFetch !== this.props.dataProduct.isFetch
    ) {
      this.setState({
        hasMoreData: this.props.dataProduct.pagination !== null
      });
    }
    if (prevProps.dataCategory !== this.props.dataCategory) {
      await this.setState({
        page: 1,
        hasMoreData: true
      });
      this._getList();
    }
  }

  _renderItems(category, data) {
    const categoryUrl =
      category === "apparels" || category === "Apparels"
        ? "apparel"
        : category === "lifestyles"
          ? "electronics-collectibles"
          : category === "handbags" ? "luxury" : category;

    return data.map((item, index) => (
      <a
        href={`/${categoryUrl}/${item.id}/${item.slug}`}
        title={item.display_name}
        key={index}
        className="sneaker-item"
      >
        <KickImage
          alt={item.display_name}
          src={item.img}
          className="sneaker-item__image"
        />
        <div className="sneaker-item__text">
          <p className="display-name">{item.display_name}</p>
          <p>{moment(item.release_date).format("DD/MM/YYYY")}</p>
        </div>
      </a>
    ));
  }

  render() {
    const {
      dataProduct: { data },
      dataCategory
    } = this.props;
    const categoryUrl =
      dataCategory === "apparels" || dataCategory === "Apparels"
        ? "apparel"
        : dataCategory === "handbags" ? "luxury" : dataCategory;
    if (data.length === 0) return null;
    return (
      <Container
        fluid
        className="editor-pick-container"
        style={data.length === 0 ? { margin: 0 } : {}}
      >
        <Row className="editor-top">
          <Col>
            <Container className="content-container">
              <h4 className="underline title black">
                <span>
                  <Link
                    to={`/${categoryUrl}/upcoming`}
                    target="_blank"
                    className="editors-release-style"
                    style={{ textDecoration: "underline" }}
                  >
                    RELEASE CALENDAR
                  </Link>
                </span>
              </h4>
              <div className="sneaker-list release">
                {data.length > 0 ? (
                  <Thumbnails
                    settings={previewSettings}
                    afterChange={this.changeImage}
                    beforeChange={this._handleBeforeChange}
                    thumbnails={data.map(item => {
                      return {
                        id: item.id,
                        slug: item.slug,
                        img: item.product_variant_images.length
                          ? getCloudImageUrl(
                            item.product_variant_images[0].URL,
                            400
                          )
                          : emptyImage(dataCategory),
                        display_name: item.display_name,
                        release_date: item.release_date
                      };
                    })}
                    active={this.state.currentIndex}
                    renderItems={data => this._renderItems(dataCategory, data)}
                  />
                ) : null}
              </div>
            </Container>
          </Col>
        </Row>
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  dataProduct: {
    data: state.dataProduct.upcomingProduct.data,
    pagination: state.dataProduct.upcomingProduct.pagination,
    isFetch: state.dataProduct.upcomingProduct.isFetch
  },
  dataCategory: state.dataCategory.selected
});

const mapDispatchToProps = dispatch => ({
  // // doFetchProducts : () => dispatch(doFetchProducts()),
  getUpcomingProducts: params => dispatch(upcomingProductPage(params))
});

export default connect(mapStateToProps, mapDispatchToProps)(ReleaseDate);
